/* Skid Steer Doors — theme behaviour */
(function () {
  'use strict';

  /* ---- Mobile nav ---- */
  var toggle = document.querySelector('[data-mobile-toggle]');
  var mnav = document.querySelector('[data-mobile-nav]');
  if (toggle && mnav) {
    toggle.addEventListener('click', function () {
      var open = !mnav.classList.contains('open');
      mnav.classList.toggle('open', open);
      mnav.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---- Find Your Door ----
     Client UX (Leighton Jul 28 + Joe Jul 29): picking a model navigates STRAIGHT to
     that door's page; the redundant "Find My Door" button is removed. Picking just a
     make shows a browse-all link so make-only visitors still have a path. */
  document.querySelectorAll('[data-fyd]').forEach(function (root) {
    var dataEl = root.querySelector('[data-fyd-data]') ||
                 document.querySelector('[data-fyd-data]');
    var MAP = {};
    try { MAP = JSON.parse(dataEl.textContent); } catch (e) { MAP = {}; }

    var makeSel = root.querySelector('[data-fyd-make]');
    var modelSel = root.querySelector('[data-fyd-model]');
    var result = root.querySelector('[data-fyd-result]');

    function fillModels() {
      var make = makeSel.value;
      modelSel.innerHTML = '<option value="">Model</option>';
      result.hidden = true;
      if (make && MAP[make] && MAP[make].models.length) {
        MAP[make].models.forEach(function (m, i) {
          var o = document.createElement('option');
          o.value = String(i);
          o.textContent = m.label;
          modelSel.appendChild(o);
        });
        modelSel.disabled = false;
        result.hidden = false;
        result.innerHTML = 'Pick your model above, or <a href="' + MAP[make].url +
          '" style="color:#FFCC4B;font-weight:700">browse all ' +
          (makeSel.options[makeSel.selectedIndex].text || 'these') + ' doors &rarr;</a>';
      } else {
        modelSel.disabled = true;
      }
    }

    makeSel.addEventListener('change', fillModels);
    modelSel.addEventListener('change', function () {
      var entry = MAP[makeSel.value];
      var mi = modelSel.value;
      if (entry && mi !== '' && entry.models[mi]) window.location.href = entry.models[mi].url;
    });
  });

  /* ---- Scroll-to-finder buttons ---- */
  document.querySelectorAll('[data-scroll-finder]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var el = document.getElementById('ssd-find-your-door');
      if (el) window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - 100), behavior: 'smooth' });
    });
  });

  /* ---- Product gallery ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) main.src = t.getAttribute('data-src');
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-pressed', 'false');
        });
        t.classList.add('is-active');
        t.setAttribute('aria-pressed', 'true');
      });
    });
  });

  /* ---- Product tabs ---- */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var btns = tabs.querySelectorAll('[data-tab]');
    var panels = tabs.querySelectorAll('[data-panel]');
    function activate(b, moveFocus) {
      var id = b.getAttribute('data-tab');
      btns.forEach(function (x) {
        var active = x === b;
        x.classList.toggle('is-active', active);
        x.setAttribute('aria-selected', String(active));
        x.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
      if (moveFocus) b.focus();
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { activate(b, false); });
      b.addEventListener('keydown', function (e) {
        var i = Array.prototype.indexOf.call(btns, b);
        var next = null;
        if (e.key === 'ArrowRight') next = btns[(i + 1) % btns.length];
        if (e.key === 'ArrowLeft') next = btns[(i - 1 + btns.length) % btns.length];
        if (e.key === 'Home') next = btns[0];
        if (e.key === 'End') next = btns[btns.length - 1];
        if (next) {
          e.preventDefault();
          activate(next, true);
        }
      });
    });
  });

  /* ---- Variant-aware displayed product price ---- */
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    function refreshVariantPrice() {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var display = option.getAttribute('data-price-display');
      if (!display) return;
      document.querySelectorAll('[data-product-price]').forEach(function (el) {
        el.textContent = display;
      });
    }
    select.addEventListener('change', refreshVariantPrice);
    refreshVariantPrice();
  });

  /* ---- Quantity steppers (data-qty-submit: cart steppers auto-save) ---- */
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    var min = input.hasAttribute('min') ? parseInt(input.getAttribute('min'), 10) : 1;
    function done(btn) {
      input.dispatchEvent(new Event('qtychange'));
      if (btn.hasAttribute('data-qty-submit') && input.form) input.form.submit();
    }
    q.querySelector('[data-qty-dec]').addEventListener('click', function () {
      input.value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
      done(this);
    });
    q.querySelector('[data-qty-inc]').addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || min) + 1;
      done(this);
    });
  });

  /* ---- FBW live subtotal: door (× qty, selected variant) + checked extras ---- */
  document.querySelectorAll('[data-fbw]').forEach(function (fbw) {
    var totalEl = fbw.querySelector('[data-fbw-total]');
    var countEl = fbw.querySelector('[data-fbw-count]');
    if (!totalEl) return;
    var form = document.getElementById(fbw.getAttribute('data-form'));
    var currency = fbw.getAttribute('data-currency') || '';
    function money(cents) {
      var n = cents / 100;
      var opts = (n % 1 === 0) ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
      return '$' + n.toLocaleString('en-US', opts) + (currency ? ' ' + currency : '');
    }
    function base() {
      var p = parseInt(fbw.getAttribute('data-base-price'), 10) || 0;
      if (form) {
        var sel = form.querySelector('select[name="id"]');
        if (sel) {
          var opt = sel.options[sel.selectedIndex];
          if (opt && opt.getAttribute('data-price')) p = parseInt(opt.getAttribute('data-price'), 10);
        }
        var qtyEl = form.querySelector('[name="quantity"]');
        var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
        return { price: p * qty, qty: qty };
      }
      return { price: p, qty: 1 };
    }
    function refresh() {
      var b = base();
      var extras = 0, n = 0;
      fbw.querySelectorAll('[data-fbw-item]:checked').forEach(function (c) {
        extras += parseInt(c.getAttribute('data-price'), 10) || 0;
        n++;
      });
      totalEl.textContent = money(b.price + extras);
      if (countEl) countEl.textContent = n > 0 ? '· door + ' + n + ' extra' + (n > 1 ? 's' : '') : '';
      // Product-page express checkout submits only the main variant, not these add-ons.
      // Keep wallets available in the cart checkout after the complete bundle is added.
      if (form) {
        var express = form.querySelector('.shopify-payment-button');
        if (express) express.style.display = n > 0 ? 'none' : '';
      }
    }
    fbw.querySelectorAll('[data-fbw-item]').forEach(function (c) { c.addEventListener('change', refresh); });
    if (form) {
      var qtyEl = form.querySelector('[name="quantity"]');
      if (qtyEl) { qtyEl.addEventListener('change', refresh); qtyEl.addEventListener('qtychange', refresh); qtyEl.addEventListener('input', refresh); }
      var sel = form.querySelector('select[name="id"]');
      if (sel) sel.addEventListener('change', refresh);
    }
    refresh();
  });

  /* ---- Theme-owned add-to-cart ----
     A third-party cart app intercepts native product-form submits and rebuilds the
     /cart/add request WITHOUT properties[Machine Model]. Document-level CAPTURE
     listeners run before any element-level app listener can, so when there is
     a product model field or checked FBW accessories, the theme takes over the
     add itself, including optional blank model entries. */
  function ssdFbwFor(form) {
    var out = null;
    document.querySelectorAll('[data-fbw]').forEach(function (fbw) {
      if (fbw.getAttribute('data-form') === form.getAttribute('id')) out = fbw;
    });
    return out;
  }
  function ssdOwnAdd(form) {
    var fbw = ssdFbwFor(form);
    var checked = fbw ? fbw.querySelectorAll('[data-fbw-item]:checked') : [];
    var idEl = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    var mainItem = { id: parseInt(idEl && idEl.value, 10), quantity: (qtyEl && parseInt(qtyEl.value, 10)) || 1 };
    var modelEl = form.querySelector('[data-model-prop]');
    if (modelEl && modelEl.value.trim()) mainItem.properties = { 'Machine Model': modelEl.value.trim() };
    var items = [mainItem];
    Array.prototype.forEach.call(checked, function (c) { items.push({ id: parseInt(c.value, 10), quantity: 1 }); });
    var btn = form.querySelector('[name="add"]');
    var status = form.querySelector('[data-fbw-status]');
    if (status) { status.hidden = true; status.textContent = ''; }
    if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok) throw new Error(body.description || body.message || 'One or more items could not be added.');
        window.location.href = '/cart';
      });
    }).catch(function (error) {
      if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
      if (status) {
        status.textContent = error.message || 'We could not add the selected items. Please try again or uncheck an accessory.';
        status.hidden = false;
        status.focus();
      } else {
        form.submit(); /* last resort: native flow still adds the main item */
      }
    });
  }
  function ssdShouldOwn(form) {
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return false;
    var modelEl = form.querySelector('[data-model-prop]');
    if (modelEl) return true;
    var fbw = ssdFbwFor(form);
    return !!(fbw && fbw.querySelectorAll('[data-fbw-item]:checked').length);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[type="submit"], button[name="add"]') : null;
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!ssdShouldOwn(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ssdOwnAdd(form);
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!ssdShouldOwn(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ssdOwnAdd(form);
  }, true);

  /* ---- Sticky mobile add-to-cart bar ---- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var primaryCta = document.querySelector('[data-primary-cta]');
  if (stickyBar && primaryCta) {
    var stickyRefreshPending = false;
    function refreshStickyBar() {
      stickyRefreshPending = false;
      stickyBar.classList.toggle('show', primaryCta.getBoundingClientRect().bottom <= 70);
    }
    function scheduleStickyRefresh() {
      if (stickyRefreshPending) return;
      stickyRefreshPending = true;
      window.requestAnimationFrame(refreshStickyBar);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(scheduleStickyRefresh, { rootMargin: '-70px 0px 0px 0px' }).observe(primaryCta);
    }
    window.addEventListener('scroll', scheduleStickyRefresh, { passive: true });
    window.addEventListener('resize', scheduleStickyRefresh);
    window.addEventListener('pageshow', scheduleStickyRefresh);
    refreshStickyBar();
  }

  /* ---- Accordion (FAQ) ---- */
  function setAccordionItem(item, open) {
    item.classList.toggle('open', open);
    var button = item.querySelector('[data-acc-q]');
    var answer = item.querySelector('.acc__a');
    if (button) {
      button.setAttribute('aria-expanded', String(open));
      var icon = button.querySelector('i');
      if (icon) icon.textContent = open ? '\u2212' : '+';
    }
    if (answer) answer.hidden = !open;
  }
  document.querySelectorAll('[data-acc-q]').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.acc__item');
      var open = item.classList.contains('open');
      var parent = item.parentNode;
      parent.querySelectorAll('.acc__item.open').forEach(function (o) {
        if (o !== item) setAccordionItem(o, false);
      });
      setAccordionItem(item, !open);
    });
  });
})();

/* ============================================================
   Guides library (bundled fallback until the blog import runs)
   ============================================================ */
(function () {
  'use strict';
  var app = document.querySelector('[data-guides-app]');
  if (!app) return;

  var grid = app.querySelector('[data-guides-grid]');
  var countEl = app.querySelector('[data-guides-count]');
  var searchEl = app.querySelector('[data-guides-search]');
  var catsEl = app.querySelector('[data-guides-cats]');
  var view = app.querySelector('[data-guide-view]');
  var toolbar = app.querySelector('.guides-toolbar');
  var GUIDES = [];
  var activeCat = 'All';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cards(list) {
    grid.innerHTML = list.map(function (g) {
      return '<a class="pcard" href="?guide=' + encodeURIComponent(g.slug) + '" data-guide-link="' + esc(g.slug) + '">' +
        '<div class="pcard__body">' +
          '<span class="guide-cat">' + esc(g.cat) + '</span>' +
          '<h3 class="guide-title">' + esc(g.title) + '</h3>' +
          '<p class="guide-ex">' + esc(g.excerpt) + '</p>' +
          '<span class="guide-read">' + esc(g.readtime) + ' &nbsp;·&nbsp; Read Guide &rarr;</span>' +
        '</div></a>';
    }).join('');
    countEl.textContent = 'Showing ' + list.length + ' of ' + GUIDES.length + ' guides';
  }

  function filtered() {
    var q = (searchEl.value || '').toLowerCase().trim();
    return GUIDES.filter(function (g) {
      if (activeCat !== 'All' && g.cat !== activeCat) return false;
      if (!q) return true;
      return (g.title + ' ' + g.excerpt + ' ' + (g.keyword || '')).toLowerCase().indexOf(q) > -1;
    });
  }

  function renderList() { cards(filtered()); }

  function showArticle(slug, push) {
    var g = GUIDES.filter(function (x) { return x.slug === slug; })[0];
    if (!g) return showList(true);
    toolbar.hidden = true; countEl.hidden = true; grid.hidden = true;
    view.hidden = false;
    view.querySelector('[data-guide-cat]').textContent = g.cat;
    view.querySelector('[data-guide-title]').textContent = g.title;
    view.querySelector('[data-guide-meta]').textContent = g.readtime + '  ·  Skid Steer Doors of North America';
    view.querySelector('[data-guide-body]').innerHTML = g.html;
    var faqWrap = view.querySelector('[data-guide-faq]');
    var faqList = view.querySelector('[data-guide-faq-list]');
    if (g.faqs && g.faqs.length) {
      faqList.innerHTML = g.faqs.map(function (f, i) {
        return '<div class="acc__item' + (i === 0 ? ' open' : '') + '">' +
          '<button class="acc__q" type="button" data-acc-q><span>' + esc(f.q) + '</span><i>' + (i === 0 ? '−' : '+') + '</i></button>' +
          '<div class="acc__a"><div class="rte"><p>' + esc(f.a) + '</p></div></div></div>';
      }).join('');
      faqWrap.hidden = false;
      /* FAQ structured data for Google + AI answer engines */
      var old = document.getElementById('guide-faq-schema');
      if (old) old.remove();
      var s = document.createElement('script');
      s.type = 'application/ld+json';
      s.id = 'guide-faq-schema';
      s.textContent = JSON.stringify({
        '@context': 'https://schema.org', '@type': 'FAQPage',
        mainEntity: g.faqs.map(function (f) {
          return { '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } };
        })
      });
      document.head.appendChild(s);
      faqList.querySelectorAll('[data-acc-q]').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.acc__item');
          var open = item.classList.contains('open');
          item.classList.toggle('open', !open);
          var icon = q.querySelector('i');
          if (icon) icon.textContent = open ? '+' : '−';
        });
      });
    } else {
      faqWrap.hidden = true;
    }
    document.title = g.title + ' — Skid Steer Doors of North America';
    if (push) history.pushState({ slug: slug }, '', '?guide=' + encodeURIComponent(slug));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function showList(push) {
    view.hidden = true;
    toolbar.hidden = false; countEl.hidden = false; grid.hidden = false;
    if (push) history.pushState({}, '', location.pathname);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  fetch(app.getAttribute('data-src'))
    .then(function (r) { return r.json(); })
    .then(function (data) {
      GUIDES = data;
      var cats = ['All'].concat(Object.keys(data.reduce(function (m, g) { m[g.cat] = 1; return m; }, {})).sort());
      catsEl.innerHTML = cats.map(function (c) {
        return '<button type="button" class="guides-cat' + (c === 'All' ? ' is-active' : '') + '" data-cat="' + esc(c) + '">' + esc(c) + '</button>';
      }).join('');
      catsEl.querySelectorAll('[data-cat]').forEach(function (b) {
        b.addEventListener('click', function () {
          activeCat = b.getAttribute('data-cat');
          catsEl.querySelectorAll('[data-cat]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
          renderList();
        });
      });
      renderList();
      var slug = new URLSearchParams(location.search).get('guide');
      if (slug) showArticle(slug, false);
    })
    .catch(function () { countEl.textContent = 'Guides could not be loaded.'; });

  grid.addEventListener('click', function (e) {
    var a = e.target.closest('[data-guide-link]');
    if (!a) return;
    e.preventDefault();
    showArticle(a.getAttribute('data-guide-link'), true);
  });
  app.querySelector('[data-guide-back]').addEventListener('click', function (e) { e.preventDefault(); showList(true); });
  searchEl.addEventListener('input', renderList);
  window.addEventListener('popstate', function () {
    var slug = new URLSearchParams(location.search).get('guide');
    if (slug) showArticle(slug, false); else showList(false);
  });
})();
